import Marionette from "backbone.marionette";

export default Backbone.Model.extend({
    urlRoot: "api/recover/index.php"
});


//////////////////
// WEBPACK FOOTER
// ./app/models/recoverModel.js
// module id = 174
// module chunks = 0